import React from 'react';

import QuestionBlock from '../../../common/QuestionBlock';

import { getInfoEmailAddress } from '../../../../utils/domain-utils';

const FaqScreen = () => {
  const emailAddress = getInfoEmailAddress();

  return (
    <div className="faq-screen" id="faq-screen-container-id">
      <p className="landing-caption-dark">FAQ</p>
      <p className="tutorium-text has-text-centered">
        Have questions? Send it to our email <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
      </p>

      <div className="tutorium-container">
        <QuestionBlock
          question="How is the training process going?"
          answer="You send a request and our manager will contact you to get more details about the training. 
          We can test your knowledge for better understanding of your level. 
          Then we create a personal training program for you depending on your needs."
        />
        <QuestionBlock
          question="Is it suitable for junior developers?"
          answer="We create a personal program for each student. 
          Our knowledge base is very big and we can create training programs for each level of student - from junior to high-qualified professional. 
          All our courses are created by professional developers and include all modern trends it IT."
        />
        <QuestionBlock
          question="What about the pricing?"
          answer="The price is individual for each person or company and depends on needs. 
        It depends on your goals, level, amount of courses and time that you want to spend on training."
        />
        <QuestionBlock
          question="Do you have any discounts?"
          answer="Yes, we have. For individual students, it depends on the program. 
          To more courses you want to learn, to cheaper each will be. 
          For companies, this rule is also valid, but in addition, we can do a discount for the number of students."
        />
      </div>
    </div>
  );
};

export default FaqScreen;
